var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpresaIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229,
    height: 182,
    viewBox: "0 0 229 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.49,
    cy: 0.5,
    r: 0.501,
    gradientTransform: "translate(0.006 -0.004) rotate(0.586)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4e8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mesa_de_trabajo_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 182
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mesa_de_trabajo_1",
    "data-name": "Mesa de trabajo \\u2013 1",
    clipPath: "url(#clip-Mesa_de_trabajo_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 182,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6953",
    "data-name": "Rect\\xE1ngulo 6953",
    width: 231,
    height: 150,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_488",
    "data-name": "Elipse 488",
    cx: 105,
    cy: 23.5,
    rx: 105,
    ry: 23.5,
    transform: "translate(11 142)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16505",
    "data-name": "Grupo 16505",
    transform: "translate(14568 7266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16502",
    "data-name": "Grupo 16502",
    transform: "translate(-869 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6910",
    "data-name": "Rect\\xE1ngulo 6910",
    width: 12,
    height: 69,
    transform: "translate(-13589 -7545)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6909",
    "data-name": "Rect\\xE1ngulo 6909",
    width: 12,
    height: 69,
    transform: "translate(-13605 -7545)",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6913",
    "data-name": "Rect\\xE1ngulo 6913",
    width: 12,
    height: 8,
    transform: "translate(-13605 -7523)",
    fill: "#cb2020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6911",
    "data-name": "Rect\\xE1ngulo 6911",
    width: 12,
    height: 8,
    transform: "translate(-13605 -7552)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6912",
    "data-name": "Rect\\xE1ngulo 6912",
    width: 12,
    height: 8,
    transform: "translate(-13589 -7552)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6916",
    "data-name": "Rect\\xE1ngulo 6916",
    width: 12,
    height: 8,
    transform: "translate(-13605 -7510)",
    fill: "#cb2020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6914",
    "data-name": "Rect\\xE1ngulo 6914",
    width: 12,
    height: 8,
    transform: "translate(-13589 -7523)",
    fill: "#cb2020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6915",
    "data-name": "Rect\\xE1ngulo 6915",
    width: 12,
    height: 8,
    transform: "translate(-13589 -7510)",
    fill: "#cb2020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6917",
    "data-name": "Rect\\xE1ngulo 6917",
    width: 6,
    height: 73,
    transform: "translate(-13599 -7552)",
    fill: "#5b5b5b",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6918",
    "data-name": "Rect\\xE1ngulo 6918",
    width: 6,
    height: 73,
    transform: "translate(-13583 -7552)",
    fill: "#5b5b5b",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6929",
    "data-name": "Rect\\xE1ngulo 6929",
    width: 9,
    height: 11,
    rx: 4.5,
    transform: "translate(-14436 -7185)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6930",
    "data-name": "Rect\\xE1ngulo 6930",
    width: 9,
    height: 11,
    rx: 4.5,
    transform: "translate(-14418 -7185)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6931",
    "data-name": "Rect\\xE1ngulo 6931",
    width: 9,
    height: 11,
    rx: 4.5,
    transform: "translate(-14496 -7185)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6932",
    "data-name": "Rect\\xE1ngulo 6932",
    width: 9,
    height: 11,
    rx: 4.5,
    transform: "translate(-14478 -7185)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6919",
    "data-name": "Rect\\xE1ngulo 6919",
    width: 126,
    height: 29,
    transform: "translate(-14515 -7180)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6921",
    "data-name": "Rect\\xE1ngulo 6921",
    width: 126,
    height: 49,
    transform: "translate(-14515 -7146)",
    fill: "#b3b1b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6920",
    "data-name": "Rect\\xE1ngulo 6920",
    width: 126,
    height: 7,
    transform: "translate(-14515 -7152)",
    fill: "#f4f2f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6924",
    "data-name": "Rect\\xE1ngulo 6924",
    width: 19,
    height: 7,
    transform: "translate(-14408 -7139)",
    fill: "#3d3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6925",
    "data-name": "Rect\\xE1ngulo 6925",
    width: 19,
    height: 7,
    transform: "translate(-14429 -7139)",
    fill: "#3d3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6926",
    "data-name": "Rect\\xE1ngulo 6926",
    width: 17,
    height: 7,
    transform: "translate(-14449 -7139)",
    fill: "#3d3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6933",
    "data-name": "Rect\\xE1ngulo 6933",
    width: 17,
    height: 7,
    transform: "translate(-14491 -7139)",
    fill: "#3d3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6934",
    "data-name": "Rect\\xE1ngulo 6934",
    width: 17,
    height: 7,
    transform: "translate(-14515 -7139)",
    fill: "#3d3b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6927",
    "data-name": "Rect\\xE1ngulo 6927",
    width: 20,
    height: 19,
    transform: "translate(-14438 -7116)",
    fill: "#464444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6928",
    "data-name": "Rect\\xE1ngulo 6928",
    width: 20,
    height: 19,
    transform: "translate(-14415 -7116)",
    fill: "#464444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6935",
    "data-name": "Rect\\xE1ngulo 6935",
    width: 20,
    height: 2,
    transform: "translate(-14438 -7116)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6943",
    "data-name": "Rect\\xE1ngulo 6943",
    width: 19,
    height: 2,
    transform: "translate(-14429 -7139)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6944",
    "data-name": "Rect\\xE1ngulo 6944",
    width: 19,
    height: 2,
    transform: "translate(-14408 -7139)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6945",
    "data-name": "Rect\\xE1ngulo 6945",
    width: 19,
    height: 2,
    transform: "translate(-14451 -7139)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6946",
    "data-name": "Rect\\xE1ngulo 6946",
    width: 19,
    height: 2,
    transform: "translate(-14493 -7139)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6947",
    "data-name": "Rect\\xE1ngulo 6947",
    width: 19,
    height: 2,
    transform: "translate(-14515 -7139)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6942",
    "data-name": "Rect\\xE1ngulo 6942",
    width: 20,
    height: 2,
    transform: "translate(-14415 -7116)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6936",
    "data-name": "Rect\\xE1ngulo 6936",
    width: 20,
    height: 2,
    transform: "translate(-14438 -7111)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6941",
    "data-name": "Rect\\xE1ngulo 6941",
    width: 20,
    height: 2,
    transform: "translate(-14415 -7111)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6937",
    "data-name": "Rect\\xE1ngulo 6937",
    width: 20,
    height: 2,
    transform: "translate(-14438 -7106)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6940",
    "data-name": "Rect\\xE1ngulo 6940",
    width: 20,
    height: 2,
    transform: "translate(-14415 -7106)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6938",
    "data-name": "Rect\\xE1ngulo 6938",
    width: 20,
    height: 2,
    transform: "translate(-14438 -7101)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6939",
    "data-name": "Rect\\xE1ngulo 6939",
    width: 20,
    height: 2,
    transform: "translate(-14415 -7101)",
    fill: "#595758"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6922",
    "data-name": "Rect\\xE1ngulo 6922",
    width: 24,
    height: 62,
    rx: 12,
    transform: "translate(-14505 -7161)",
    fill: "#00875a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6923",
    "data-name": "Rect\\xE1ngulo 6923",
    width: 24,
    height: 62,
    rx: 12,
    transform: "translate(-14472 -7161)",
    fill: "#00875a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6948",
    "data-name": "Rect\\xE1ngulo 6948",
    width: 14,
    height: 39,
    transform: "translate(-14495 -7150)",
    fill: "#006544"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6949",
    "data-name": "Rect\\xE1ngulo 6949",
    width: 14,
    height: 39,
    transform: "translate(-14462 -7150)",
    fill: "#006544"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6950",
    "data-name": "Rect\\xE1ngulo 6950",
    width: 68,
    height: 14,
    transform: "translate(-14511 -7111)",
    fill: "#e0e0e2",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6951",
    "data-name": "Rect\\xE1ngulo 6951",
    width: 68,
    height: 4,
    transform: "translate(-14511 -7111)",
    fill: "#f6f6f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresaIcono);
export default __webpack_public_path__ + "static/media/empresa-icono.caab03cd01686498d666d6960fa7294b.svg";
export { ForwardRef as ReactComponent };